import { render, staticRenderFns } from "./RipaStopsWithErrorsGrid.vue?vue&type=template&id=13bc631c"
import script from "./RipaStopsWithErrorsGrid.vue?vue&type=script&lang=js"
export * from "./RipaStopsWithErrorsGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaStopsWithErrorsGrid.vue?vue&type=style&index=0&id=13bc631c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports